import { useEffect, useState } from 'react';

export default function useTouchDevice() {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const hasTouchSupport =
      (typeof window !== 'undefined' && 'ontouchstart' in window) ||
      (typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0);

    setIsTouchDevice(hasTouchSupport);
  }, []);

  return [isTouchDevice];
}
